import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { useState, useCallback } from 'react';

/**
 * @description
 * boolean 타입으로 useState를 쉽게 사용할 수 있는 hook 입니다.
 *
 * ```ts
 * function useBooleanState(defaultValue = false): readonly [bool, setTrue, setFalse, toggle];
 * ```
 *
 * @example
 * const [open, openBottomSheet, closeBottomSheet, toggleBottomSheet] = useBooleanState(false);
 */

var useBooleanState = function useBooleanState() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useState = useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      bool = _useState2[0],
      setBool = _useState2[1];

  var setTrue = useCallback(function () {
    setBool(true);
  }, []);
  var setFalse = useCallback(function () {
    setBool(false);
  }, []);
  var toggle = useCallback(function () {
    setBool(function (b) {
      return !b;
    });
  }, []);
  return [bool, setTrue, setFalse, toggle];
};

export { useBooleanState };
